<template>
  <div :class="classObj" class="app-wrapper">
    <project></project>
    <el-container>
      <div
        v-if="device === 'mobile' && sidebar.opened"
        class="drawer-bg"
        @click="handleClickOutside"
      />
      <div
        :class="urlFile == 'ja' || 'olar' ? 'navRain' : 'navRain1'"
        id="navRain"
        v-show="isFold"
      >
        <div v-if="this.show" class="secondMenuLogo">
          <div class="sidebarlogo" v-if="urlFile == 'ja'"></div>
          <div class="sidebarlogo1" v-if="urlFile == 'HK'"></div>
          <div class="sidebarlogo2" v-if="urlFile == 'MINI'"></div>
          <div class="sidebarlogo3" v-if="urlFile == 'Olar'"></div>
        </div>
        <!-- <secondMenuLogo></secondMenuLogo> -->
        <secondBar></secondBar>
        <Sidebar class="sidebar-container" id="sidebar-container"></Sidebar>
      </div>
      <el-container
        class="main-container"
        id="main-container"
        :class="{
          'fixed-header': fixedHeader,
          foldStyle: !isFold,
        }"
      >
        <div class="border-top">
          <el-header :class="isFold ? '' : 'el-header1'">
            <heade ref="heade"></heade>
          </el-header>
        </div>
        <!-- 导航标签 -->
        <div><tag></tag></div>
        <div class="bodymain">
          <el-main>
            <right></right>
          </el-main>
        </div>
        <el-footer
          >©Copyright2022深圳归谷智能有限公司.AllRightsReserved</el-footer
        >
      </el-container>
    </el-container>
  </div>
</template>

<script>
import tag from "@/components/tag/index.vue";
import Sidebar from "./components/Sidebar/index.vue";
import right from "./home/index_home.vue";
// import ResizeMixin from "./mixin/ResizeHandler";
// import right from "@/view/system/role"
import heade from "./components/TagsView/index.vue";
import { mapState } from "vuex";
// import login from '@/api/login';
import Logo from "@/assets/images/logo2.png";
import secondBar from "./components/secondBar";
import project from "@/components/selectObject";
export default {
  inject: ["reload"],
  created() {
    let monile = this.$store.state.app.device;
  },
  mounted() {
    this.IsPC();
    if (process.env.VUE_APP_API_BASE_NAME == "hk") {
      this.urlFile = "HK";
    } else if (process.env.VUE_APP_API_BASE_NAME == "ja") {
      this.urlFile = "ja";
    } else if (process.env.VUE_APP_API_BASE_NAME == "mini") {
      this.urlFile = "MINI";
    } else if (process.env.VUE_APP_API_BASE_NAME == "olar") {
      this.urlFile = "Olar";
    }
  },
  data() {
    return {
      logo: Logo,
      nav: require("@/assets/images/e.png"),
      mobile: "",
      show: true,
      urlFile: "",
    };
  },
  components: {
    tag,
    Sidebar,
    right,
    heade,
    secondBar,
    project,
  },
  // mixins: [ResizeMixin],
  computed: {
    ...mapState({
      sidebar: (state) => state.app.sidebar,
      device: (state) => state.app.device,
      showSettings: (state) => state.settings.showSettings,
      needTagsView: (state) => state.settings.tagsView,
      fixedHeader: (state) => state.settings.fixedHeader,
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile",
      };
    },
    language() {
      return this.$i18n.locale;
    },
    isFold: {
      get() {
        console.log(!this.sidebar.isFold, "!this.sidebar.isFold", !this.mobile);
        if (this.mobile) {
          return true;
        } else {
          console.log(99);
          return !this.sidebar.isFold;
        }
      },
      set() {},
    },
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch("closeSideBar", { withoutAnimation: false });
    },
    IsPC() {
      let userAgent = navigator.userAgent.toLowerCase();
      // 用 test 匹配浏览器信息
      if (
        /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(
          userAgent
        )
      ) {
        this.mobile = false;
        this.show = false;
        console.log("前端是移动端");
      } else {
        this.mobile = true;
        this.show = true;
        console.log("前端是pc端");
      }
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/mixin.scss";
@import "~@/assets/styles/variables.scss";
// @import '~@/assets/styles/sidebar.scss';
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  min-width: 980px;
  min-height: 800px;
  overflow-x: auto;
  overflow-y: auto;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.el-header,
.el-footer {
  color: #333;
  text-align: center;
  line-height: 35px;
  position: fixed;
  background-color: #ffffff;
}
.el-header {
  border-radius: 20px 0 0 0;
  padding: 0;
  position: absolute;
}
.el-header1 {
  border-radius: 0;
}
.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.0001s;
  padding: 0;
}
// .main{
//   background-color: red;
//   height: 100%;
// }
.el-main {
  position: absolute;
  width: 100%;
  transition: margin-left 0.00028s;
  background-color: #ffffff;
  padding: 0;
  //  background-color: transparent !important;
  // padding-bottom: 50px;
  overflow: hidden;
}
.bodymain {
  height: 100%;
  background-color: rgb(255, 255, 255);
}
// .border-top {
//   background-color: #5abde3;
// }
.el-container {
  height: 100%;
}
.main-container {
  height: 100%;
  min-height: 100%;
  transition: margin-left 0.28s;
  margin-left: $sideBarWidth;
  position: relative;
  -webkit-transition: margin-left 0.28s;
  -moz-transition: margin-left 0.28s;
  -ms-transition: margin-left 0.28s;
  -o-transition: margin-left 0.28s;
}

.secondMenuLogo {
  float: right;
  clear: both;
  right: 0;
  width: 100%;
  height: 50px;
  padding: auto;
  line-height: 40px;
  font-size: 20px;
  margin-top: 20px;
  // background-color: green;
}
.sidebarlogo,
.sidebarlogo1,
.sidebarlogo2 {
  background-size: contain;
  background-repeat: no-repeat;
}

.sidebar-container {
  transition: width 0.28s;
  // width: $sideBarWidth !important;
  border-radius: 0 40px 40px 0;
  position: fixed;
  font-size: 0;
  top: 85px;
  bottom: 0px;
  left: 0;
  border: none;
  z-index: 1001;
  overflow: hidden;
  user-select: none;
  .horizontal-collapse-transition {
    transition: 0s width ease-in-out, 0s padding-left ease-in-out,
      0s padding-right ease-in-out;
  }

  // .scrollbar-wrapper {
  //   overflow-y: hidden !important;
  // }

  .el-scrollbar__bar.is-vertical {
    right: 0;
  }

  .el-scrollbar {
    height: 100%;
    overflow: hidden;
  }

  &.has-logo {
    .el-scrollbar {
      // height: calc(100% - 50px);
      overflow: hidden !important;
    }
  }

  .is-horizontal {
    display: none;
  }

  a {
    display: inline-block;
    width: 100%;
    overflow: hidden;
  }

  .svg-icon {
    margin-right: 16px;
  }

  .el-menu {
    border: none;
    height: 100%;
    width: 100% !important;
  }

  // menu hover
  .submenu-title-noDropdown,
  .el-submenu__title {
    &:hover {
      background-color: $menuHover !important;
      color: white !important;
    }
  }

  .is-active > .el-submenu__title {
    color: $subMenuActiveText !important;
  }

  & .nest-menu .el-submenu > .el-submenu__title,
  & .el-submenu .el-menu-item {
    min-width: $sideBarWidth !important;
    background-color: $subMenuBg !important;

    &:hover {
      background-color: $subMenuHover !important;
    }
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}
// .hideSidebar .fixed-header {
//   width: calc(100% - 54px);
// }

.mobile .fixed-header {
  width: 100%;
}

.mobile .navRain {
  border-top-right-radius: 40px;
  border-bottom-right-radius: 40px;
}
.mobile .sidebar-container {
  top: 1px;
}
.el-footer {
  padding: auto;
  position: fixed;
  color: rgb(131, 130, 130);
  bottom: 0;
  font-size: 10px;
  width: 100%;
  height: 35px !important;
  border-top: 1px solid #e7eaec;
  background-color: rgb(255, 255, 255);
  z-index: 100000;
  // letter-spacing: 1px;
  text-align: left;
}
.mobile .el-footer {
  left: 0;
}
.el-header {
  position: relative;
  height: 60px !important;
}
.mobile {
  .main-container {
    margin-left: 0;
  }
  .navRain {
    transition: transform 0.28s;
    width: $sideBarWidth !important;
  }
  .sidebar-container {
    transition: transform 0.28s;
    width: $sideBarWidth !important;
  }

  &.hideSidebar {
    .sidebar-container {
      pointer-events: none;
      transition-duration: 0.3s;
      transform: translate3d(-$sideBarWidth, 0, 0);
    }
    .navRain {
      pointer-events: none;
      transition-duration: 0.3s;
      width: 0 !important;
      z-index: 0;
      transform: translate3d(-$sideBarWidth, 0, 0);
    }
  }
}
.foldStyle {
  margin: 0;
}
</style>
